import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { route } from '../../route/Index';
import { useAppDispatch } from '../../store/hook';
import { cleanProject } from '../../store/project/projectSlice';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { cleanResult } from '../../store/result/resultSlice';
import { cleanAlert } from '../../store/alert/alertSlice';
import Span from '../../shared/component/Span';
import { Stack } from '@mui/material';
import { cleanEngine } from '../../store/engine/engineSlice';
import { cleanMap } from '../../store/map/mapSlice';

interface INewProps {}

const New = (props: INewProps) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const { t } = useTranslation();

    const handleClick = () => {
        dispatch(cleanProject());
        dispatch(cleanResult());
        dispatch(cleanEngine());
        dispatch(cleanMap());
        dispatch(cleanAlert());
        navigate(route.info);
    };

    return (
        <Stack>
            <Button variant='greenLight' startIcon={<AddCircleOutlineIcon />} onClick={handleClick}>
                <Span text={t('new')} />
            </Button>
        </Stack>
    );
};

export default New;
